import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import { InWinImage } from 'routes/shared/components'

import * as styles from './styles'

const TriggerCellComponent = ({
  value: {
    eventDTO: { teamOne, teamTwo, matchName, sportType },
    binaryWinner,
    description,
  },
}) => {
  // Check if this is a custom event (no teams)
  const isCustomEvent = !teamOne || !teamTwo || sportType === 'athletics' || sportType === 'other';

  if (isCustomEvent) {
    return (
      <div css={styles.container}>
        <div css={styles.teamItem}>
          {description && (
            <Text size={11} css={styles.customEventDesc}>
              {description}
            </Text>
          )}
        </div>
      </div>
    );
  }

  // Regular team event logic
  const teamThatPickedForWin = binaryWinner === 'TEAM_A' ? teamOne : teamTwo
  const teamThatPickedForLose = binaryWinner === 'TEAM_A' ? teamTwo : teamOne

  return (
    <div css={styles.container}>
      <div css={styles.teamItem} style={{ marginRight: 40 }}>
        <InWinImage
          source={teamThatPickedForWin.logo}
          alt={teamThatPickedForWin.teamName}
          css={styles.logo}
        />
        <Text size={11}>{teamThatPickedForWin.teamName}</Text>
      </div>
      <Text size={11} css={styles.winnerLabel}>Defeats</Text>
      <div css={styles.teamItem}>
        <InWinImage
          source={teamThatPickedForLose.logo}
          alt={teamThatPickedForLose.teamName}
          css={styles.logo}
        />
        <Text size={11}>{teamThatPickedForLose.teamName}</Text>
      </div>
    </div>
  )
}

TriggerCellComponent.propTypes = {
  value: PropTypes.shape({
    eventDTO: PropTypes.shape({
      teamOne: PropTypes.shape(),
      teamTwo: PropTypes.shape(),
      matchName: PropTypes.string,
      sportType: PropTypes.string,
    }),
    binaryWinner: PropTypes.string,
    description: PropTypes.string,
  }),
}

export default TriggerCellComponent
